'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifierConfig = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = exports.modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return '\n    background: ' + theme.colors.base.chrome000 + ';\n    border-left: 2px solid ' + theme.colors.brand.primary + ';\n  ';
  },

  ghost: function ghost(_ref2) {
    var theme = _ref2.theme;
    return '\n    border: none;\n    padding: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n\n    &:hover {\n      background: ' + theme.colors.base.chrome100 + ';\n    }\n  ';
  },

  highlight: function highlight(_ref3) {
    var theme = _ref3.theme;
    return '\n    background: ' + theme.colors.base.chrome000 + ';\n  ';
  }
};

var styles = function styles(_ref4) {
  var theme = _ref4.theme;
  return '\n  align-items: center;\n  background: ' + theme.colors.base.chrome100 + ';\n  border-left: 2px solid transparent;\n  box-sizing: border-box;\n  display: flex;\n  height: ' + theme.dimensions.leftNavWidthCollapsed + ';\n  padding: 0;\n  pointer-events: auto;\n\n\n  &: hover {\n   background: ' + theme.colors.base.chrome000 + ';\n\n    .MenuItemTitleText {\n      text-decoration: underline;\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome100: _propTypes2.default.string.isRequired
    }).isRequired,
    brand: _propTypes2.default.shape({
      primary: _propTypes2.default.shape.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    leftNavWidthCollapsed: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuItemTitle', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/LeftNav/MenuItemTitle.js
// module id = 1585
// module chunks = 2